import { toast as sonner } from 'sonner';

/**
 * Avisos do editor sobre o `sonner` do app, com a API que o núcleo usa:
 * `success`, `error`, `info`, `warning` e `operation` (o aviso curto de uma
 * operação, com "Desfazer" quando há como voltar atrás).
 */
export const toast = {
  success: (mensagem: string) => { sonner.success(mensagem); },
  error: (mensagem: string) => { sonner.error(mensagem); },
  info: (mensagem: string) => { sonner.info(mensagem); },
  warning: (mensagem: string) => { sonner.warning(mensagem); },
  operation: (mensagem: string, desfazer?: () => void | Promise<void>, opcoes?: { duration?: number }) => {
    sonner(mensagem, {
      duration: opcoes?.duration ?? 3000,
      action: desfazer ? { label: 'Desfazer', onClick: () => { void desfazer(); } } : undefined,
    });
  },
};
